/* Oxalis — header interactions: nav drawer with multi-level "back" navigation,
   search overlay with predictive search, wishlist counter, scroll lock. */
(function () {
  'use strict';

  var body = document.body;
  var scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    body.style.position = 'fixed';
    body.style.top = -scrollY + 'px';
    body.style.width = '100%';
  }

  function unlockScroll() {
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  /* ---------------- Nav drawer ---------------- */
  var drawer = document.querySelector('[data-drawer]');
  var drawerStack = [];
  // Reassigned below (inside `if (drawer)`) only when the drawer's own
  // search field actually has voice search wired up; stays a safe no-op
  // otherwise so closeDrawer() can always call it unconditionally.
  var stopDrawerVoiceSearch = function () {};

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.setAttribute('data-open', '');
    });
    lockScroll();
    resetDrawer();
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    // Never leave the drawer's own mic running once the panel is gone —
    // covers the "X", the backdrop tap, the swipe-to-close and Escape,
    // since all of them call closeDrawer().
    stopDrawerVoiceSearch();
    drawer.removeAttribute('data-open');
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    window.setTimeout(function () {
      drawer.hidden = true;
      resetDrawer();
    }, 300);
    unlockScroll();
  }

  function currentList() {
    return drawerStack[drawerStack.length - 1];
  }

  function updateDrawerChrome() {
    var backBtn = drawer.querySelector('[data-drawer-back]');
    var title = drawer.querySelector('[data-drawer-title]');
    var list = currentList();
    if (title && list) title.textContent = list.getAttribute('data-menu-title') || '';
    // Back is always available: it steps up one level inside a submenu, and
    // closes the drawer outright once already at the top level (see
    // drawerBack) — so it's never hidden, unlike before.
    if (backBtn) backBtn.hidden = false;
  }

  function resetDrawer() {
    var root = drawer.querySelector('[data-menu-level="0"]');
    drawer.querySelectorAll('.nav-drawer__list--child').forEach(function (el) {
      el.hidden = true;
    });
    drawerStack = root ? [root] : [];
    updateDrawerChrome();
  }

  function openSubmenu(button) {
    var submenu = button.parentElement.querySelector('.nav-drawer__list--child');
    if (!submenu) return;
    submenu.hidden = false;
    drawerStack.push(submenu);
    updateDrawerChrome();
    // Skip the inline "← Retour" row (see [data-submenu-back] below) when
    // moving focus into the new panel: a visitor who just went forward
    // should land on real content, not immediately on a way back out.
    var firstLink = submenu.querySelector('a, button:not([data-submenu-back])');
    if (firstLink) firstLink.focus();
  }

  function drawerBack() {
    if (drawerStack.length <= 1) {
      // Already at the top level: "back" simply closes the drawer and
      // returns to the page currently shown behind it (no submenu to pop).
      closeDrawer();
      return;
    }
    var leaving = drawerStack.pop();
    if (leaving) leaving.hidden = true;
    updateDrawerChrome();
  }

  if (drawer) {
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    var backBtn = drawer.querySelector('[data-drawer-back]');
    if (backBtn) backBtn.addEventListener('click', drawerBack);
    drawer.querySelectorAll('[data-submenu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openSubmenu(btn);
      });
    });
    // Second, in-panel way back (sections/header.liquid): calls the exact
    // same drawerBack() as the header's own "← Retour" — one history, one
    // piece of navigation logic, never two systems that could desync.
    drawer.querySelectorAll('[data-submenu-back]').forEach(function (btn) {
      btn.addEventListener('click', drawerBack);
    });

    /* Voice search on the drawer's own inline search field — same shared
       implementation as the main search overlay (initVoiceSearch above).
       This field has no predictive search of its own, so the only thing
       the mic feeds is the plain native form submit already in place. */
    var drawerSearchForm = drawer.querySelector('.nav-drawer__search');
    if (drawerSearchForm) {
      var drawerSearchInput = drawerSearchForm.querySelector('input[type="search"]');
      // Scoped to the whole drawer, not just the form: the status/waveform
      // element sits right after the form as its own sibling (sections/
      // header.liquid), same as the mic button's markup convention there.
      stopDrawerVoiceSearch = initVoiceSearch(drawer, drawerSearchInput);
      drawerSearchForm.addEventListener('submit', function () {
        stopDrawerVoiceSearch();
      });
    }

    /* Swipe right-to-left anywhere on the panel closes the drawer outright
       (never steps back a submenu level — same as tapping the close "X").
       See bindSwipeToClose() below. */
    bindSwipeToClose(drawer.querySelector('.nav-drawer__panel'), function () {
      return drawer.hasAttribute('data-open');
    }, closeDrawer);
  }

  /* ---------------- Shared swipe-to-close gesture ----------------
     Touch/pen only — mouse is never part of this gesture at all. A real
     mouse click nearly always drifts a pixel or two between mousedown and
     mouseup (unlike a scripted/synthetic click, which never does), and
     capturing the pointer on down — as this used to do for any primary
     mouse button too — hijacked that drift into "gesture tracking",
     which could keep the browser's click synthesis from ever reaching
     whatever button/link was actually under the cursor. Desktop closes
     and links now go through nothing but their own native click.
     For touch/pen: pointer capture itself is deferred until a real
     horizontal swipe is confirmed (~10px moved, and more horizontal than
     vertical) — a plain tap never captures the pointer at all, so it
     stays a completely ordinary tap the whole way through, and a vertical
     drag is hand-ed back to native scroll immediately instead of being
     captured. Only once swipe intent is confirmed does this take over the
     pointer, and the actual close decision is still made on release, from
     the final delta — closes only on a clear right-to-left swipe past the
     threshold. `isOpen` lets each caller report its own open state (a
     `data-open` attribute, a `hidden` flag, …) without this helper
     assuming one particular convention. */
  function bindSwipeToClose(panel, isOpen, close) {
    if (!panel) return;
    var tracking = false;
    var captured = false;
    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var SWIPE_INTENT_THRESHOLD = 10; // px moved before a touch/pen gesture is judged horizontal vs vertical

    panel.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse') return;
        if (!isOpen()) return;
        tracking = true;
        captured = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
      },
      { passive: true }
    );

    panel.addEventListener(
      'pointermove',
      function (e) {
        if (!tracking || e.pointerId !== pointerId || captured) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.abs(dx) < SWIPE_INTENT_THRESHOLD && Math.abs(dy) < SWIPE_INTENT_THRESHOLD) return;
        if (Math.abs(dx) <= Math.abs(dy)) {
          // Vertical intent — never captured, native scroll keeps going.
          tracking = false;
          return;
        }
        // Real horizontal swipe confirmed — only now take over the pointer.
        captured = true;
        if (panel.setPointerCapture) {
          try {
            panel.setPointerCapture(pointerId);
          } catch (err) {
            /* capture is best-effort; gesture still works without it */
          }
        }
      },
      { passive: true }
    );

    function end(e) {
      if (!tracking || e.pointerId !== pointerId) return;
      tracking = false;
      if (!captured) return; // never became a swipe — a tap, left as a tap
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      var threshold = Math.max(70, panel.clientWidth * 0.2);
      var isHorizontal = Math.abs(dx) > Math.abs(dy) * 1.5;
      if (isHorizontal && dx <= -threshold) close();
    }

    panel.addEventListener('pointerup', end, { passive: true });
    panel.addEventListener('pointercancel', function () {
      tracking = false;
      captured = false;
    });
  }

  /* ---------------- Voice search (progressive enhancement, shared) ----------------
     One SpeechRecognition state machine, reused by every field that offers
     a mic — the main search overlay and the nav drawer's own inline search
     — so there is only ever one implementation to keep correct. Transcribes
     speech into `input` only; it never queries anything itself, so each
     caller's own existing search pipeline (predictive search, or the
     drawer's native form submit) is the only thing that actually searches.
     Hidden by default in the markup; revealed here only when the browser
     genuinely exposes the Web Speech API. Returns a `stop` function the
     caller can call from its own closing/navigating paths (submit, result
     click, drawer close, …) on top of the pagehide/visibility net already
     wired in here. */
  function initVoiceSearch(scope, input) {
    var noop = function () {};
    if (!scope || !input) return noop;
    var voiceBtn = scope.querySelector('[data-search-voice]');
    var voiceStatus = scope.querySelector('[data-search-voice-status]');
    var voiceStatusText = scope.querySelector('[data-search-voice-status-text]');
    var SpeechRecognitionCtor = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!voiceBtn || !SpeechRecognitionCtor) return noop;

    var recognition = null;
    var voiceRetriedLang = false;
    var voiceStatusClearTimer = null;
    var voiceSafetyTimer = null;

    function setVoiceStatus(text) {
      if (!voiceStatus) return;
      window.clearTimeout(voiceStatusClearTimer);
      if (voiceStatusText) voiceStatusText.textContent = text || '';
      voiceStatus.hidden = !text;
    }

    function setListeningState(isListening) {
      voiceBtn.setAttribute('aria-pressed', isListening ? 'true' : 'false');
      voiceBtn.setAttribute(
        'aria-label',
        isListening ? voiceBtn.getAttribute('data-label-listening') : voiceBtn.getAttribute('data-label-default')
      );
      voiceBtn.classList.toggle('is-listening', isListening);
      // Also drives the CSS-only waveform bars: showing/animating them
      // needs no microphone access of its own — there is only ever the
      // one mic use, SpeechRecognition itself.
      if (voiceStatus) voiceStatus.classList.toggle('is-listening', isListening);
    }

    // The single, central stop for this instance — safe to call any number
    // of times, even with no session running.
    var stop = function () {
      window.clearTimeout(voiceSafetyTimer);
      voiceSafetyTimer = null;
      if (recognition) {
        var current = recognition;
        recognition = null;
        // Detach the end handler first: this is a deliberate stop, not a
        // natural end, so it shouldn't run the "linger the message" logic.
        current.onend = null;
        try {
          current.stop();
        } catch (e) {
          /* already stopped/aborted — nothing to do */
        }
      }
      setListeningState(false);
      setVoiceStatus('');
    };

    var start = function (lang) {
      var rec;
      try {
        rec = new SpeechRecognitionCtor();
      } catch (e) {
        return; // construction failing counts as "unavailable" — stay silent
      }
      recognition = rec;
      rec.lang = lang;
      // One short dictation per tap: no session is meant to stay open
      // while the visitor reads or acts on results.
      rec.continuous = false;
      rec.interimResults = true;
      rec.maxAlternatives = 1;

      rec.onstart = function () {
        setListeningState(true);
        setVoiceStatus(voiceBtn.getAttribute('data-status-listening'));
        // Safety net only: if the API never fires a final result or "end"
        // for some reason, don't let listening run forever.
        voiceSafetyTimer = window.setTimeout(function () {
          stop();
        }, 8000);
      };

      rec.onresult = function (e) {
        var transcript = '';
        var isFinal = false;
        for (var i = 0; i < e.results.length; i++) {
          transcript += e.results[i][0].transcript;
          if (e.results[i].isFinal) isFinal = true;
        }
        input.value = transcript;
        // Feed the exact same pipeline a keyboard keystroke would — the
        // caller's own "input" listener (predictive search, or nothing
        // beyond native behaviour for the drawer's plain field) — and
        // nothing else.
        input.dispatchEvent(new Event('input', { bubbles: true }));
        if (isFinal) {
          // A final, exploitable phrase: stop right away rather than
          // waiting for the browser's own "end" — this is what keeps the
          // microphone from staying open while results are browsed.
          stop();
        }
      };

      rec.onerror = function (e) {
        if (e.error === 'language-not-supported' && lang !== 'fr-FR' && !voiceRetriedLang) {
          voiceRetriedLang = true;
          recognition = null;
          start('fr-FR');
          return;
        }
        if (e.error === 'not-allowed' || e.error === 'service-not-allowed') {
          setVoiceStatus(voiceBtn.getAttribute('data-status-denied'));
        } else if (e.error === 'no-speech') {
          setVoiceStatus(voiceBtn.getAttribute('data-status-no-match'));
        } else {
          // Any other interruption: quietly back to the normal state,
          // never a technical error message.
          setVoiceStatus('');
        }
      };

      rec.onend = function () {
        window.clearTimeout(voiceSafetyTimer);
        voiceSafetyTimer = null;
        recognition = null;
        setListeningState(false);
        if (voiceStatus && !voiceStatus.hidden) {
          // Leave an error/empty-result message on screen briefly rather
          // than snapping it away instantly.
          voiceStatusClearTimer = window.setTimeout(function () {
            setVoiceStatus('');
          }, 3000);
        }
        input.focus();
      };

      try {
        rec.start();
      } catch (e) {
        recognition = null;
        setListeningState(false);
      }
    };

    voiceBtn.hidden = false;
    voiceBtn.addEventListener('click', function () {
      if (recognition) {
        // Tapping again while listening cancels early, same outcome as
        // running out of speech — never two sessions at once.
        stop();
        return;
      }
      // Straight to the browser's own permission flow: it asks natively
      // the first time, and starts dictation immediately once it's
      // already been granted. No Oxalis-side prompt in between.
      voiceRetriedLang = false;
      start('fr-BE');
    });

    // Last-resort net for any navigation path this particular instance's
    // caller doesn't already cover explicitly (submit, result click, …):
    // never leave this session's mic open once the tab is hidden/left.
    window.addEventListener('pagehide', stop);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
    });

    return stop;
  }

  /* ---------------- Search overlay ---------------- */
  var search = document.querySelector('[data-search]');
  var predictiveTimer;
  // Reassigned below (inside `if (search)`) only when voice search is
  // actually wired up; stays a safe no-op otherwise so closeSearch() can
  // always call it unconditionally.
  var stopVoiceSearch = function () {};

  function openSearch() {
    if (!search) return;
    search.hidden = false;
    lockScroll();
    var input = search.querySelector('[data-predictive-search-input]');
    if (input) window.setTimeout(function () { input.focus(); }, 50);
    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
  }

  function closeSearch() {
    if (!search) return;
    // Never leave a microphone session running once the panel is gone —
    // covers the "X", the backdrop tap, the swipe-to-close and Escape,
    // since all of them call closeSearch().
    stopVoiceSearch();
    search.hidden = true;
    unlockScroll();
    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  if (search) {
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', openSearch);
    });
    search.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSearch);
    });

    /* Same right-to-left swipe convention as the nav drawer, on the search
       panel itself (the overlay has no side-slide animation, but the
       gesture still gives touch users a consistent way to dismiss it). */
    bindSwipeToClose(search.querySelector('.search-overlay__panel'), function () {
      return !search.hidden;
    }, closeSearch);

    var input = search.querySelector('[data-predictive-search-input]');
    var results = search.querySelector('[data-predictive-search-results]');

    if (input && results) {
      input.addEventListener('input', function () {
        window.clearTimeout(predictiveTimer);
        var term = input.value.trim();
        if (term.length < 2) {
          results.innerHTML = '';
          return;
        }
        predictiveTimer = window.setTimeout(function () {
          fetchPredictive(term, results);
        }, 250);
      });
    }

    /* Same shared implementation as the nav drawer's own search field —
       see initVoiceSearch() above. */
    stopVoiceSearch = initVoiceSearch(search, input);

    /* ---- Stop the microphone the instant the user actually leaves ----
       initVoiceSearch() already covers pagehide/tab-hidden on its own, but
       tapping a predictive result or the search button navigates the
       browser directly, without ever closing the overlay first. Stopping
       proactively here, before the navigation even starts, is what keeps
       the microphone from lingering during that gap on some browsers
       (notably iOS Safari's back/forward cache). */
    if (results) {
      results.addEventListener('click', function (e) {
        if (e.target.closest('a')) stopVoiceSearch();
      });
    }
    var searchForm = search.querySelector('[data-predictive-search-form]');
    if (searchForm) {
      searchForm.addEventListener('submit', function () {
        stopVoiceSearch();
      });
    }
  }

  /* ---------------- Search term normalization (tolerant retry) ----------------
     Shopify's own predictive search stays the only search engine here — this
     never queries anything itself, it only computes an alternate spelling
     of the same term to retry with, ONCE, and only when the original typed
     term came back completely empty. Three deterministic, general rules
     (no per-product data needed, so this keeps working for every future
     product automatically):
       1. a tiny, curated map for a handful of real catalogue mismatches
          (e.g. the common French "bleuet" vs. the catalogue's own "Bluet"
          spelling, and feminine/plural forms of the 9 real colours);
       2. accent folding (é/è/ê → e, …) — French search should tolerate a
          visitor typing "ble" and still reach "Blé";
       3. a plain trailing "s" stripped for words over 3 letters — a plain
          French plural (e.g. "bluets" → "bluet").
     Never a parallel search index — Shopify's own relevance engine still
     decides what actually matches; this only gives it a better-spelled
     second try. */
  var SEARCH_TERM_SYNONYMS = {
    bleuet: 'bluet',
    bleuets: 'bluet',
    bleue: 'bleu',
    bleues: 'bleu',
    bleus: 'bleu',
    blanche: 'blanc',
    blanches: 'blanc',
    verte: 'vert',
    vertes: 'vert',
    verts: 'vert',
  };

  var ACCENT_MAP = {
    à: 'a', â: 'a', ä: 'a',
    é: 'e', è: 'e', ê: 'e', ë: 'e',
    î: 'i', ï: 'i',
    ô: 'o', ö: 'o',
    ù: 'u', û: 'u', ü: 'u',
    ç: 'c',
  };

  function foldAccents(word) {
    var out = '';
    for (var i = 0; i < word.length; i++) {
      var ch = word.charAt(i);
      out += ACCENT_MAP[ch] || ch;
    }
    return out;
  }

  function normalizeSearchTerm(term) {
    return term
      .toLowerCase()
      .split(/\s+/)
      .map(function (word) {
        if (SEARCH_TERM_SYNONYMS[word]) return SEARCH_TERM_SYNONYMS[word];
        var folded = foldAccents(word);
        if (folded.length > 3 && folded.slice(-1) === 's') folded = folded.slice(0, -1);
        return folded;
      })
      .join(' ');
  }

  function fetchPredictive(term, container, isRetry) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    var endpoint =
      root +
      'search/suggest.json?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product,page,article&resources[limit]=6';

    fetch(endpoint)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        var items = []
          .concat(res.products || [], res.pages || [], res.articles || [])
          .slice(0, 8);
        if (!items.length) {
          if (!isRetry) {
            var normalized = normalizeSearchTerm(term);
            if (normalized && normalized !== term.toLowerCase().trim()) {
              fetchPredictive(normalized, container, true);
              return;
            }
          }
          container.innerHTML = '<p class="predictive-results__empty">' + '—' + '</p>';
          return;
        }
        var html = '<ul class="predictive-results__list">';
        items.forEach(function (item) {
          var img =
            item.image || (item.featured_image && item.featured_image.url) || '';
          html +=
            '<li class="predictive-results__item"><a href="' +
            item.url +
            '">' +
            (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : '') +
            '<span>' + item.title + '</span></a></li>';
        });
        html += '</ul>';
        container.innerHTML = html;
      })
      .catch(function () {
        container.innerHTML = '';
      });
  }

  /* ---------------- Global escape + counters ---------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    if (search && !search.hidden) closeSearch();
  });

  function refreshWishlistCount() {
    var count = 0;
    try {
      var stored = JSON.parse(localStorage.getItem('oxalis:wishlist') || '[]');
      count = Array.isArray(stored) ? stored.length : 0;
    } catch (e) {
      count = 0;
    }
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  refreshWishlistCount();
  document.addEventListener('oxalis:wishlist:change', refreshWishlistCount);
  window.addEventListener('storage', function (e) {
    if (e.key === 'oxalis:wishlist') refreshWishlistCount();
  });

  /* ---------------- Cookie-consent banner: reserve its space ----------------
     Shopify's own cookie-consent banner (#shopify-pc__banner) is injected
     automatically (Customer Privacy) with a very high z-index, and it's
     bottom-anchored — exactly where the nav-drawer's own footer
     (Compte/Favoris/social links) sits. Nothing here ever changes the
     banner itself (no hiding, no moving, no z-index race, no privacy
     logic touched) — this only measures its real, live height into
     --cookie-banner-h (see .nav-drawer__panel above), so the drawer
     reserves that much space at its own bottom and every row stays
     reachable, scrolled into view like any other. The variable resets to
     0 the instant the banner is gone (Accepter/Refuser, or if it was
     never shown at all).
     One lightweight, targeted MutationObserver — not a broad subtree
     watch: the banner is always a direct child of <body>, so watching
     only body's own childList is enough to catch it being inserted or
     removed, and it only fires on that rare event (not on every DOM
     change on the page). */
  (function watchCookieBanner() {
    var root = document.documentElement;
    var watched = null;
    var ro = null;

    function setHeight(px) {
      root.style.setProperty('--cookie-banner-h', px + 'px');
    }

    function watch(el) {
      if (watched === el) return;
      if (ro) {
        ro.disconnect();
        ro = null;
      }
      watched = el;
      if (!el) {
        setHeight(0);
        return;
      }
      if ('ResizeObserver' in window) {
        // getBoundingClientRect() (not entries[0].contentRect, which
        // excludes padding/border) so the reserved space matches the
        // banner's true, full rendered height exactly.
        ro = new ResizeObserver(function () {
          setHeight(el.getBoundingClientRect().height);
        });
        ro.observe(el);
      } else {
        setHeight(el.offsetHeight);
      }
    }

    function check() {
      watch(document.getElementById('shopify-pc__banner'));
    }

    check();
    if ('MutationObserver' in window) {
      new MutationObserver(check).observe(document.body, { childList: true });
    }
  })();

})();
